import type { DailyRiseTop30Item } from "@/types/daily-rise-top30"
import client from "./client"

export async function getDailyRiseTop30(code: string): Promise<DailyRiseTop30Item[]> {
  const { data } = await client.get<DailyRiseTop30Item[]>(`/api/daily-rise-top30/${code}`)
  return data
}
